function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import * as Icon from "./icons";

var SocialConnect =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(SocialConnect, _Component);

  function SocialConnect() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = SocialConnect.prototype;

  _proto.render = function render() {
    return React.createElement("div", null, React.createElement("a", {
      href: "https://github.com/aranhaagency",
      target: "_blank",
      rel: "noopener noreferrer"
    }, React.createElement(Icon.Github, null)), React.createElement("a", {
      href: "https://www.linkedin.com/in/aranha-agency-a15b81185/",
      target: "_blank",
      rel: "noopener noreferrer"
    }, React.createElement(Icon.Linkedin, null)), React.createElement("a", {
      href: "https://twitter.com/aranhaagency",
      target: "_blank",
      rel: "noopener noreferrer"
    }, React.createElement(Icon.Twitter, null)), React.createElement("a", {
      href: "https://instagram.com/aranhaagency",
      target: "_blank",
      rel: "noopener noreferrer"
    }, React.createElement(Icon.Instagram, null)));
  };

  return SocialConnect;
}(Component);

export default SocialConnect;